<template>
  <form ref="pickupForm">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="companyName">{{ $t("company_name") }}</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="companyName"
                  required
                  id="companyName"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="name">{{ $t("sender_name") }}</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control text-capitalize"
                  v-model="name"
                  required
                  id="name"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="phoneNumber">{{ $t("phone_num") }}</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="phoneNumber"
                  required
                  id="phoneNumber"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="email">{{ $t("email") }}</label>
              <div class="input-group">
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  required
                  id="email"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="address">{{ $t("address") }}</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="address"
                  required
                  id="address"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="notes">{{ $t("notes") }}</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="notes"
                  id="notes"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "PickupDetailsStep",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      companyName: this.initialValues?.companyName ?? "",
      name: this.initialValues?.name ?? "",
      phoneNumber: this.initialValues?.phoneNumber ?? "",
      email: this.initialValues?.email ?? "",
      address: this.initialValues?.address ?? "",
      notes: this.initialValues?.notes ?? "",
    };
  },
  methods: {
    validateForm() {
      const form = this.$refs.pickupForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        companyName: this.companyName,
        name: this.name,
        phoneNumber: this.phoneNumber,
        email: this.email,
        address: this.address,
        notes: this.notes,
      };
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        if (newValues.name) {
          this.companyName = newValues.companyName || "";
          this.name = newValues.name || "";
          this.phoneNumber = newValues.phoneNumber || "";
          this.email = newValues.email || "";
          this.address = newValues.address || "";
          this.notes = newValues.notes || "";
        }
      },
      deep: true,
    },
  },
};
</script>
